import axios from "axios";

export const state = {
    dispensemedicines: [],
};

export const getters = {
    dispensemedicines: state => state.dispensemedicines,
};

export const mutations = {
    setPayments(state, newValue) {
        state.dispensemedicines = newValue
    },
};

export const actions = {
    fetchDispenseMedicine({ commit }) {
        axios.get('/dispensemedicine').then(res => {
            commit('setPayments', res.data.prescriptions)
        })
    },
};
